import React, { Suspense } from 'react';
import {
  CourseHomepageContainer,
  CourseHomeRight,
  CouseHomeLeft,
} from '../TakeCourse/CourseHome.styles';
import CourseSideMenu from '../TakeCourse/CourseHomeSideMenu.component';
import { useParams } from 'react-router-dom';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import CourseDataDisplayed from '../TakeCourse/CourseData.component';
import CourseDataProvider from '../../Utils/Courses/CourseDataProvider';
import { AuthCheckUser } from '../../Utils/AuthCheck/UserCheck.auth';

const CourseReview = () => {
  const { id } = useParams();

  return (
    <Suspense fallback={<div>Loading course...</div>}>
      <AuthCheckUser>
        <HelmetHelper title="Review Course" description="Review the course" />
        <CourseDataProvider courseId={id}>
          {(course) => (
            <CourseHomepageContainer>
              <CourseHomeRight>
                <CourseSideMenu
                  course={course}
                  status="Course has been completed"
                />
              </CourseHomeRight>
              <CouseHomeLeft>
                <CourseDataDisplayed data={course} />
              </CouseHomeLeft>
            </CourseHomepageContainer>
          )}
        </CourseDataProvider>
      </AuthCheckUser>
    </Suspense>
  );
};

export default CourseReview;
